import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { trackMetaCustomEvent } from "@/lib/meta-pixel/meta-pixel";

const Register = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated || hasStartedRef.current) {
      return;
    }

    hasStartedRef.current = true;
    trackMetaCustomEvent("RegistrationStarted", {
      entrypoint: "register",
    });

    void loginWithRedirect({
      appState: {
        returnTo: "/",
      },
      fragment: "register",
    });
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading) {
    return <div>Lade...</div>;
  }
  if (!isAuthenticated) {
    return <div>Redirecting...</div>;
  }

  return <Navigate to="/" replace />;
};

export default Register;
